<template>
  <div>
    <v-menu
      v-model="ativador_menu"
      open-on-hover
      left
      offset-y
      transition="slide-y-transition"
      open-delay="500"
      close-delay="500"
      close-on-click
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <slot name="ativador" :on="on" :attrs="attrs">
          <v-btn v-bind="attrs" v-on="on" icon @click.stop>
            <v-icon>mdi-alert</v-icon>
          </v-btn>
        </slot>
      </template>

      <div class="div-menu">
        <div class="px-3 pb-1 pt-2 d-flex align-center">
          <v-icon small>mdi-alert</v-icon>
          <span class="font-weight-medium font-13 pl-1">Alerta</span>

          <v-spacer />

          <v-btn icon x-small @click="ativador_menu = false">
            <v-icon size="16">mdi-close</v-icon>
          </v-btn>
        </div>

        <v-divider></v-divider>

        <div class="px-3 pb-3">
          <p class="ma-0 mt-2 font-weight-medium">
            Quantidade de compra divergente do lote mínimo ({{
              Helpers.formatarValor(loteMinimo)
            }})
          </p>

          <div style="display: flex" class="mt-2">
            <p class="ma-0">
              Corrigir para cima:
              {{ Helpers.formatarValor(novaSugestaoUp) }}
            </p>

            <v-btn
              color="#043554"
              class="ml-2"
              x-small
              rounded
              dark
              @click="() => $emit('change', this.novaSugestaoUp)"
            >
              aplicar
            </v-btn>
          </div>

          <div v-if="novaSugestaoDown > 0" style="display: flex" class="mt-2">
            <p class="ma-0">
              Corrigir para baixo:
              {{ Helpers.formatarValor(novaSugestaoDown) }}
            </p>

            <v-btn
              color="#043554"
              class="ml-2"
              x-small rounded
              dark
              @click="() => $emit('change', this.novaSugestaoDown)"
            >
              aplicar
            </v-btn>
          </div>

          <div
            v-if="config_lote_minimo_a_partir_de && Number(valorModel) > Number(loteMinimo)"
            style="display: flex"
            class="mt-2"
          >
            <p class="ma-0">
              Comprar fora do lote:
              {{ Helpers.formatarValor(valorModel) }}
            </p>

            <v-btn
              color="warning"
              class="ml-2"
              x-small rounded
              @click="() => $emit('forcar-sugestao', valorModel)"
            >
              confirmar
            </v-btn>
          </div>
        </div>
      </div>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "ValidaLoteMinimo",
  model: {
    prop: "valorModel",
    event: "change",
  },
  props: {
    valorModel: {
      type: [Number, String],
      required: true,
    },
    loteMinimo: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      ativador_menu: false,
      config_lote_minimo_a_partir_de: localStorage.config_lote_minimo_a_partir_de === 'S'
    };
  },
  computed: {
    novaSugestaoUp() {
      if (parseFloat(this.valorModel) == 0) {
        return parseFloat(this.loteMinimo);
      }

      if (parseFloat(this.valorModel) % parseFloat(this.loteMinimo) === 0) {
        return 0;
      }

      const loteMinimoAux =
        parseFloat(this.loteMinimo) > 0 ? parseFloat(this.loteMinimo) : 1;

      if (parseFloat(this.valorModel) > parseFloat(loteMinimoAux)) {
        return (
          loteMinimoAux -
          (parseFloat(this.valorModel) % loteMinimoAux) +
          parseFloat(this.valorModel)
        );
      } else {
        return loteMinimoAux;
      }
    },
    novaSugestaoDown() {
      return this.novaSugestaoUp - this.loteMinimo;
    },
  },
};
</script>

<style scoped>
.div-menu {
  background: #ffffff;
  font-size: 12.5px;
}
</style>
